import { useCallback } from 'react';

import { useGetVmsSources } from '@vlabs/api/point-api/client';
import type { VmsVendorSource } from '@vlabs/api/point-api/model';

export interface VmsSourcesResponse {
  data: VmsVendorSource[];
}

function selectVmsSource(
  sources: VmsVendorSource[],
  sourceName: string,
): VmsVendorSource | null {
  const matchedSources = sources.filter(({ luna_name }) => luna_name === sourceName);
  const macroscopSource = matchedSources.find(({ vendor }) => vendor === 'macroscop');

  return macroscopSource ?? matchedSources[0] ?? null;
}

interface UseVmsFromSourceNameResult {
  vmsSource: VmsVendorSource | null;
}

export function useVmsFromSourceName(
  sourceName?: string | null,
): UseVmsFromSourceNameResult {
  const selectSource = useCallback(
    (response: VmsSourcesResponse) => selectVmsSource(response.data, sourceName ?? ''),
    [sourceName],
  );
  const query = useGetVmsSources<VmsVendorSource | null>(undefined, {
    query: {
      enabled: !!sourceName,
      select: (response) => selectSource(response as unknown as VmsSourcesResponse),
    },
  });

  return {
    vmsSource: query.data ?? null,
  };
}
